export default "__VITE_ASSET__DxZMTIQN__"